import PremissasAssinaturasView from "../../components/gestaoOrcamentaria/PremissasAssinaturasView";

export default function PremissasAssinaturas() {
  return <PremissasAssinaturasView />;
}
